export default "__VITE_ASSET__Crqq_FwV__"